import React from 'react'

const ClockOrange = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 25 24"
      fill="none"
      style={{ marginTop: '2px' }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_4152_108146"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect x="0.5" width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_4152_108146)">
        <path
          d="M15.125 16.025C15.3083 16.2083 15.5333 16.3 15.8 16.3C16.0667 16.3 16.3 16.2 16.5 16C16.6833 15.8167 16.775 15.5833 16.775 15.3C16.775 15.0167 16.6833 14.7833 16.5 14.6L13.5 11.6V7.975C13.5 7.69167 13.4043 7.45833 13.213 7.275C13.021 7.09167 12.7833 7 12.5 7C12.2167 7 11.9793 7.09567 11.788 7.287C11.596 7.479 11.5 7.71667 11.5 8V11.975C11.5 12.1083 11.525 12.2373 11.575 12.362C11.625 12.4873 11.7 12.6 11.8 12.7L15.125 16.025ZM12.5 22C11.1167 22 9.81667 21.7373 8.6 21.212C7.38333 20.6873 6.325 19.975 5.425 19.075C4.525 18.175 3.81267 17.1167 3.288 15.9C2.76267 14.6833 2.5 13.3833 2.5 12C2.5 10.6167 2.76267 9.31667 3.288 8.1C3.81267 6.88333 4.525 5.825 5.425 4.925C6.325 4.025 7.38333 3.31233 8.6 2.787C9.81667 2.26233 11.1167 2 12.5 2C13.8833 2 15.1833 2.26233 16.4 2.787C17.6167 3.31233 18.675 4.025 19.575 4.925C20.475 5.825 21.1873 6.88333 21.712 8.1C22.2373 9.31667 22.5 10.6167 22.5 12C22.5 13.3833 22.2373 14.6833 21.712 15.9C21.1873 17.1167 20.475 18.175 19.575 19.075C18.675 19.975 17.6167 20.6873 16.4 21.212C15.1833 21.7373 13.8833 22 12.5 22Z"
          fill="#F3A66E"
        />
      </g>
    </svg>
  )
}

export default ClockOrange
